export default __webpack_public_path__ + "static/fallback-aok-small-47fc1134d63dbb683fba0c66c68c60f1.png";